<template>
  <!-- 优惠券卡片组件 -->
  <div class="card">
    <div class="dentation"></div>
    <img class="disableImg" :src="disableImgUrl" v-if="disable && disableImgUrl" @click.stop="showRightDetail(datas)" />
    <van-row class="fvlr" @click.stop="showRightDetail(datas)">
      <van-col span="8">
        <div class="fhcud rightsTypeWrap">
          <van-divider dashed :style="dividerStyle">
            {{ datas.typeName }}
          </van-divider>
          <p class="rightsCore" :class="{ disable }">
            {{ datas.discountStr }}
          </p>
          <p>{{ datas.thresholdStr }}</p>
        </div>
      </van-col>
      <van-col span="1">
        <div class="dashedBox"></div>
      </van-col>
      <van-col span="15">
        <div class="fhlud rightsInfoBox">
          <p class="rightsName ellipsis">
            {{ datas.rightName ? datas.rightName : '暂无名称' }}
          </p>
          <p class="ellipsis" v-if="limitStr">
            {{ limitStr }}
          </p>
          <p v-if="datas.activeTypeFlag == 1">有效期：{{ datas.activeStartTime }}-{{ datas.activeEndTime }}</p>
          <p v-else>有效期：{{ datas.activeMonth == -1 ? '无限制' : `${datas.activeMonth || ''}个月` }}</p>
          <slot></slot>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
export default {
  props: {
    datas: {
      type: Object,
      default: () => {}
    },
    disable: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    isMy: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(props, { emit }) {
    let { datas, disable, isDetail, isMy } = toRefs(props)
    const state = reactive({
      datas,
      disable,
      isDetail,
      isMy,
      dividerStyle: {
        color: '#999',
        borderColor: '#aaa',
        margin: 0,
        lineHeight: '12px'
      }
    })
    // 触发点击事件
    const showRightDetail = data => {
      emit('click', data)
    }
    // 计算限制条件
    const limitStr = computed(() => {
      let str = ''
      let { distributeTypeFlag, dealerInfo = {} } = state.datas
      let arrStr = ['', '', '']
      if (state.isMy) {
        arrStr = ['', `仅限${dealerInfo?.name || ''}使用`, '适用全网经销商']
      } else {
        if (state.isDetail) {
          arrStr = ['', '', '适用全网经销商']
        }
      }
      str = arrStr[distributeTypeFlag] ? arrStr[distributeTypeFlag] : ''
      return str
    })
    const disableImgUrl = computed(() => {
      let statusFlag = state.disable && state.datas.statusFlag
      let data = (statusFlag && require(`../../assets/images/status${statusFlag}.png`)) || ''
      return data
    })

    return {
      ...toRefs(state),
      showRightDetail,
      limitStr,
      disableImgUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  padding: 12px 0;
  background: #ffffff;
  font-size: 12px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.08);
}

.disableImg {
  position: absolute;
  width: 70px;
  height: 70px;
  top: 0;
  right: 0px;
}

// 边缘锯齿
.dentation {
  position: absolute;
  width: 5px;
  height: 90px;
  top: 0;
  left: -4px;
  background-image: url(../../assets/images/dentation.png);
}
// 左侧类型
.rightsTypeWrap {
  padding: 0 6px;
  color: #999;
  height: 66px;
  text-align: center;
  .rightsCore {
    color: #3088c5;
    font-size: 22px;
    font-weight: 700;
  }
  .disable {
    color: #999;
  }
}

// 分隔虚线
.dashedBox {
  height: 66px;
  width: 1px;
  height: 66px;
  border-right: 1px dashed #ccc;
}

// 右侧信息
.rightsInfoBox {
  height: 66px;
  color: #666;
  text-align: left;
  p {
    max-width: 100%;
  }
  .rightsName {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
